export default {
  /* eslint-disable no-dupe-keys */
  user: {
    name: '用户',
    detail_tags: {
      detail: '基本信息',
      orders: '订单记录',
      order_statistics: '订单统计',
      top_ups: '充值记录',
      withdraw_application: '提现记录',
      setting: '配置',
      billing: '账单',
      discounts: '优惠信息',
      activity_info: '活动',
      tickets: '工单'
    },
    discount_tags: {
      charging_packages: '用户充电包',
      charging_cards: '用户充电卡',
      coupons: '用户优惠券',
      groups: '用户集团'
    },
    activity_info_tags: {
      trigger_outcomes: '优惠活动参与记录',
      activity_participations: '活动邀请记录',
      product_orders: '商品订单记录',
      station_activities: '站桩访问记录',
      feedbacks: '意见反馈'
    },
    title: {
      topup_statistics: '用户充值汇总',
      order_statistics: '用户订单汇总'
    },
    // 属性
    prop: {
      nick_name: '昵称',
      mobile: '手机',
      tags: '标签',
      user_type: '类型',
      status: '状态',
      gender: '性别',
      first_oauth_type: '注册渠道',
      last_sign_in_at: '最后登录时间',
      balance: '余额',
      points: '积分',
      description: '描述',
      created_at: '注册时间',
      updated_at: '更新时间',
      ws_online_at: '上线时间',
      internal_stations: '充电可用站',
      last_start_charge_time: '最近启动时间',
      paid_orders_count: '充电次数',
      paid_orders_amount: '充电金额',
      first_ev_charging_station: '首次充电站点',
      app_client: '客户端',
      cars: '车辆信息',
      ev_charging_stations_count: '充电的电站数量',
      ip: 'IP',
      ip_city_name: '用户IP归属',
      miniprogram_ws_online_at: '小程序在线',
      android_ws_online_at: '安卓在线',
      ios_ws_online_at: 'iOS在线',
      is_vip: '是否会员',
      first_charge_start_time: '首次充电时间',
      groups: '加入的集团',
      created_at: '首次开通时间',
      idle_fee_relief_count: '已减免占位次数',
      idle_fee_waived: '免收占位费',
      allow_multi_charging: '是否允许多充',
      amount: '金额',
      description: '说明',
      money_type: '金额类型',
      admin_password: '管理员密码'
    },
    statistics_prop: {
      topup_count: '充值次数',
      topup_amount: '充值金额',
      topup_time: '充值时间',
      order_count: '充电次数',
      order_amount: '充电金额',
      order_time: '充电结束时间',
      charging_started_at: '充电开始时间'
    },
    // 列表页字段（search display也重用）
    // Enum的属性
    user_types: {
      normal: '普通',
      internal: '内部'
    },
    is_vips: {
      true: '是会员',
      false: '不是会员'
    },
    allow_multi_chargings: {
      true: '允许多充',
      false: '不允许多充'
    },
    // 会员类型
    statuses: {
      active: '生效中',
      disabled: '已禁用',
      blocked: '已上锁'
    },
    genders: {
      male: '男',
      female: '女',
      unknown: '未知'
    },
    app_clients: {
      miniprogram: '小程序',
      android: '安卓',
      ios: 'iOS'
    },
    // 占位提示
    placeholder: {
      search_keyword: '查询昵称/手机/描述'
    },
    btn: {
      send: '发信息/优惠',
      statistics: '用户日/月统计',
      user_order_statistics: '用户订单汇总',
      user_topup_statistics: '用户充值汇总'
    },
    button: {
      statistics: '确认查询',
      topup_statistics: '用户充值汇总',
      order_statistics: '用户订单汇总'
    },
    label: '用户',
    gender: {
      male: '男',
      female: '女',
      unknown: '未知'
    },
    nick_name: '昵称',
    user_type: {
      normal: '普通用户',
      internal: '内部用户',
      group: '集团用户'
    },
    status: '状态',
    statuses: {
      active: '正常',
      disabled: '锁定',
      blocked: '黑名单'
    },
    edit: {
      free_charge: '免费充电站'
    },
    show: {
      whether_to_determine: '是否确定将用户',
      pull_in_blacklist: '加入黑名单',
      removed_blacklist: '移出黑名单',
      unlocked: '解除锁定',
      instructions: '说明 （必填项）',
      confirm_block: '确认拉黑',
      confirm_remove: '确认移出',
      confirm_relieve: '确认解除',
      current_balance: '当前余额',
      label: '用户',
      top_up_success: '充值成功',
      top_up_fail: '充值失败',
      input_correct_money: '请输入正确的金额',
      password_error: '密码有误'
    },
    top_ups: {
      top_up_alert: '了解',
      tip: {
        actual: '本次充值到用户的「基础账户」, 该账户的余额支持提现',
        reward: '本次充值到用户的「赠送账户」, 该账户的余额不支持提现'
      }
    },
    operation: {
      platform_top_up_title: '平台支付',
      platform_withdraw_title: '平台提现',
      delete_user_title: '删除用户',
      disabled_user_title: '禁用登录',
      add_blocked_title: '加入黑名单',
      remove_blocked_title: '移出黑名单',
      enabled_user_title: '解除禁用',
      descriptions: {
        platform_top_up: '后台管理员手动对该用户的余额账户进行充值，一般适用于内部用户或特殊情况下需要进行账户充值的普通用户。',
        platform_withdraw:
          '后台管理员手动对该用户的余额账户进行提现，一般适用于内部用户或提出余额提现申请的普通用户。此操作一般会在财物人员实际划账后进行。',
        add_blocked: '将用户加入黑名单后，用户将无法正常充电，同时管理员可通过“移出黑名单”的操作恢复用户权限。',
        remove_blocked: '将用户移出黑名单后，用户可以正常充电，同时管理员可通过“加入黑名单”的操作禁用用户权限。'
      },
      operation_tab_key: {
        description: '充值备注',
        data_certificate: '资料凭证',
        current_operator: '当前操作人',
        authentication: '身份验证',
        top_up: '充值',
        reward: '赠送',
        base: '基础'
      },
      placeholders: {
        password: '请输入管理员密码',
        max_withdraw_amount: '最大提现金额 {0} 元'
      },
      buttons: {
        confirm_top_up: '确认充值',
        cancel: '取消'
      },
      expenditure: '流出',
      income: '流入',
      income_count: '资金流入',
      expend_count: '资金流出',
      trend_chart_title: '流入流出累计趋势图（近一年）',
      variety_chart_title: '流入流出月环比图（近一年）'
    },
    payment_setting: {
      point_records: '积分记录'
    },
    withdraw: {
      label: {
        amount: '金额',
        description: '提现备注',
        certificate: '资料凭证',
        operator: '操作人',
        authentication: '身份验证'
      },
      btn: {
        withdraw: '确认提现',
        apply: '申请提现'
      },
      tip: {
        application: '注：申请提现，审核通过即可到账',
        withdraw: '注：请线下转账，确保退款金额到（用户）账上'
      },
      // 提现错误
      error_msg: {
        BALANCE_NOT_ENOUGH: '余额不足',
        OVER_RANGE: '超出可提现金额',
        ADMIN_PASSWORD_ERROR: '管理员密码错误'
      },
      // 提现成功
      success_msg: {
        created_withdraw_application: '成功申请了提现，请继续进行下一步审核!',
        created_withdraw: '成功提现，账号余额已经扣减!'
      }
    },
    labels: {
      today_new_users_count: '今日注册用户数',
      today_online_users_count: '今日在线用户数',
      today_charge_users_count: '今日充电用户数',
      today_miniprogram_users_count: '今日小程序在线数',
      today_android_users_count: '今日安卓在线数',
      today_ios_users_count: '今日iOS在线数',
      total_active_vip_members_count: '生效中 VIP 会员数'
    },
    titles: {
      base_info: '基本信息',
      vip_member: '会员信息',
      app_info: '手机客户端',
      station_info: '电站轨迹',
      car_info: '车辆信息',
      wallet: '钱包',
      magcard_info: '磁卡信息',
      activity_info: '充电活动'
    },
    tips: {
      allow_multi_charging: '仅适用于本方 APP 用户，第三方渠道用户默认允许多充，不受配置影响。'
    }
  }
}
